import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardsIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.95005 12.825C4.95005 13.1978 5.25226 13.5 5.62505 13.5C5.99784 13.5 6.30005 13.1978 6.30005 12.825V9.67499C6.30005 9.3022 5.99784 8.99999 5.62505 8.99999C5.25226 8.99999 4.95005 9.3022 4.95005 9.67499L4.95005 12.825Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.22505 13.5C8.85226 13.5 8.55005 13.1978 8.55005 12.825L8.55005 6.97499C8.55005 6.6022 8.85226 6.29999 9.22505 6.29999C9.59784 6.29999 9.90005 6.6022 9.90005 6.97499V12.825C9.90005 13.1978 9.59784 13.5 9.22505 13.5Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.15 12.825C12.15 13.1978 12.4523 13.5 12.825 13.5C13.1978 13.5 13.5 13.1978 13.5 12.825V5.17499C13.5 4.8022 13.1978 4.49999 12.825 4.49999C12.4523 4.49999 12.15 4.8022 12.15 5.17499V12.825Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.80005 3.59999C1.80005 2.60588 2.60594 1.79999 3.60005 1.79999H14.4C15.3942 1.79999 16.2 2.60588 16.2 3.59999V14.4C16.2 15.3941 15.3942 16.2 14.4 16.2H3.60005C2.60594 16.2 1.80005 15.3941 1.80005 14.4V3.59999ZM3.60005 3.14999H14.4C14.6486 3.14999 14.85 3.35146 14.85 3.59999V14.4C14.85 14.6485 14.6486 14.85 14.4 14.85H3.60005C3.35152 14.85 3.15005 14.6485 3.15005 14.4V3.59999C3.15005 3.35146 3.35152 3.14999 3.60005 3.14999Z",
                fill: color || "#676879"
            })
        ]
    });
